import React from 'react';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface FormDialogProps {
  formMode: FormMode;
}

const FormDialog: React.FC<FormDialogProps> = ({ formMode }) => {
  const isViewMode = formMode === 'view';

  return (
    <div className='max-h-[calc(100vh-150px)] gap-y-4 overflow-y-auto p-4'>
      <div className='flex items-center'>
        <Label htmlFor='loai_tg_ts' className='min-w-40'>
          Loại tăng giảm
        </Label>
        <FormField
          id='loai_tg_ts'
          type='select'
          name='loai_tg_ts'
          className='w-full'
          disabled={isViewMode}
          options={[
            { value: '1', label: '1. Tăng tài sản' },
            { value: '2', label: '2. Giảm tài sản' }
          ]}
        />
      </div>
      <div className='flex items-center'>
        <Label className='min-w-40'>Mã tăng giảm</Label>
        <FormField
          type='text'
          className='w-full'
          name='ma_tg_ts'
          disabled={formMode === 'view' || formMode === 'edit'}
        />
      </div>

      <div className='flex items-center'>
        <Label className='min-w-40'>Tên tăng giảm</Label>
        <FormField type='text' name='ten_tg_ts' className='w-full' disabled={isViewMode} />
      </div>

      <div className='flex items-center'>
        <Label className='min-w-40'>Tên khác</Label>
        <FormField type='text' name='ten_tg_ts2' disabled={isViewMode} />
      </div>

      <div className='flex items-center'>
        <Label htmlFor='status' className='min-w-40'>
          Trạng thái
        </Label>
        <FormField
          id='status'
          type='select'
          name='status'
          className='w-full'
          disabled={isViewMode}
          options={[
            { value: '1', label: '1. Còn sử dụng' },
            { value: '0', label: '0. Không sử dụng' }
          ]}
        />
      </div>
    </div>
  );
};

export default FormDialog;
